import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Toast celebrativo allo sblocco di nuovi trofei (polling /auth/me)
export function useBadgeToasts() {
  const navigate = useNavigate();
  const { data: meFresh } = useQuery({
    queryKey: ["me-badges"],
    queryFn: async () => (await api.get("/auth/me")).data,
    refetchInterval: 20000,
  });
  useEffect(() => {
    if (!meFresh?.badges) return;
    try {
      const known = JSON.parse(localStorage.getItem("badges-known") || "[]");
      const fresh = meFresh.badges.filter((b) => !known.includes(b.key));
      fresh.forEach((b) =>
        toast.success(`TROFEO SBLOCCATO! ${b.icona} ${b.nome}`, {
          description: b.descrizione,
          duration: 6000,
          action: { label: "Vedi nel Profilo", onClick: () => navigate("/profile") },
        })
      );
      if (fresh.length) {
        localStorage.setItem("badges-known", JSON.stringify([...known, ...fresh.map((b) => b.key)]));
      }
    } catch {
      // diff badge non critico
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meFresh]);
}
